import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/tetrahedron.svg
 */
const IconTetrahedron: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M1.63 18.399l9.835 5.47a1.12 1.12 0 001.047 0l9.836-5.47a1.106 1.106 0 00.436-1.485v-.028L12.92.531a1.062 1.062 0 00-.663-.499 1.064 1.064 0 00-.82.125 1.186 1.186 0 00-.379.374L1.222 16.886a1.138 1.138 0 00.412 1.513H1.63zM13.093 5.016l7.219 12.043-7.219 4.018V5.016zm-2.208 0v16.069l-7.19-4.018 7.19-12.051z"
      fill="currentColor"
    />
  </svg>
);

export default IconTetrahedron;
